import React from 'react';
import styled from 'styled-components';

interface IconProps {
    onClick?: () => void;
    size?: number;
}

const IconWrapper = styled.button<{ size?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.size || 28}px;
  height: ${props => props.size || 28}px;
  border-radius: 4px;
  background-color: #666;
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #555;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 120, 255, 0.3);
  }

  svg {
    transition: transform 0.2s ease-in-out;
  }
`;

export const AddIcon: React.FC<IconProps> = ({ onClick, size }) => {
    return (
        <IconWrapper onClick={onClick} size={size} aria-label="Add">
            <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 1V13M1 7H13"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </IconWrapper>
    );
};

export const MinusIcon: React.FC<IconProps> = ({ onClick, size }) => {
    return (
        <IconWrapper onClick={onClick} size={size} aria-label="Collapse">
            <svg
                width="14"
                height="2"
                viewBox="0 0 14 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 1H13"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </IconWrapper>
    );
};
